<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="partnoAlt"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            v-if="verNuevo == 0"
            >

  
    
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>WorkFlow</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center"   v-if="verNuevo == 0" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                   <!--<v-btn @click="listPartnoAlt()" color="primary" dark class="mb-2">Seach</v-btn> -->
                    
                    <v-spacer></v-spacer>
                    
                    <v-btn color="primary"  class="mb-2" @click="showNew" v-if="verNuevo == 0" dark >New item</v-btn>
                                                            
             

            </v-toolbar>
                 <template>                  
                    <v-row>
                        <v-dialog v-model="adModal" persistent max-width="290px">
                            <v-card>
                                <v-card-title class="headline" v-if="adAccion == 1">Active Item?</v-card-title>
                                <v-card-title class="headline" v-if="adAccion == 2">Desactive Item?</v-card-title>
                                <v-card-text>
                                    Are you sure to
                                    <span v-if="adAccion==1">Activate </span>
                                    <span v-if="adAccion==2">Deactivate </span>
                                    this WorkFlow: {{adName}} ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text="text" @click="activateDesactivateClose">
                                        Cancel
                                    </v-btn>
                                    <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activate">
                                        Activate
                                    </v-btn>
                                    <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="deactivate">
                                        Deactivate
                                    </v-btn>
                                    
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

  



                    </v-row>                    
                </template>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.id_flow">
                            <td>
                                <div >  
                                    <div >                                  
                                        <v-icon small class="mr-2" @click="editItem(item)">
                                            edit
                                        </v-icon>
                                        <template v-if="item.condition">
                                            <v-icon small class="mr-2" @click="activeDesactiveItem(2,item)">
                                                block
                                            </v-icon>
                                        </template>
                                        <template v-else="item.condition">
                                            <v-icon small class="mr-2" @click="activeDesactiveItem(1,item)">
                                                check
                                            </v-icon>
                                        </template>
                                    </div>
                                </div>                                                                                               
                            </td>                  
                                                        
                            <td class="text-xs-right">{{item.flowname}} </td>                              
                            
                            <td class="text-xs-right">                                                        
                                <div v-if="item.condition">
                                    <span class="blue--text">Active</span>                                    
                                </div>
                                <div v-else>
                                <span class="red--text">Inactive</span>
                                </div>                                
                            </td>                        
                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                           

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
           </v-data-table>
           
         <v-container  grid-list-sm class="pa-4 white"  v-if="verNuevo"> 



  <!--Contact List Ini -->       
                       <v-dialog v-model="verContactos" persistent max-width="1000px"   >
                            <v-card>
                                <v-card-title> 
                                    <span class="headline">
                                        Select a contact 
                                    </span> 
                                </v-card-title>                            
                            
                                <v-card-text>


<!--DataTable ini-->
                                     <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                  
                                        
                                            <v-flex xs12 sm12 md12 lg12 xl12>
                                                <v-text-field 
                                                append-icon="search" 
                                                class="text-xs-center"
                                                v-model="texto"
                                                label="Input userName to search"
                                                @keyup.enter="listContact()"
                                                ></v-text-field>
                                                <template>
                                                    <v-data-table 
                                                        :headers="headersContact"
                                                        :items="contactos"
                                                        :search="search"                                                                                 
                                                        class="elevation-1"
                                                        >
                                                        <template v-slot:top>
                                                                <v-toolbar flat color="white"> 
                                                                <v-toolbar-title>Contact list</v-toolbar-title> 
                                                                <v-divider
                                                                    class="mx-4"
                                                                    inset
                                                                    vertical
                                                                ></v-divider>                  
                                                               
                                                      

                                                        </v-toolbar>
                                                        
                                                    </template>
                                                        
                                                            <template v-slot:body="{ items }">
                                                                <tbody>
                                                                    <tr v-for="item in items" :key="item.ID">
                                                                        <td >
                                                                            <div >  
                                                                                <div >                                  
                                                                                    <v-icon 
                                                                                    small 
                                                                                    class="mr-2"
                                                                                     @click="addContact(item)">
                                                                                        add
                                                                                    </v-icon>                                                       
                                                                                
                                                                                </div>
                                                                            </div>                                                                                               
                                                                        </td>                  

                                                                        <td class="text-xs-right">{{item.badgeid}} </td>
                                                                        <td class="text-xs-right">{{item.contactname}} </td> 
                                                                        <td class="text-xs-right">                                                
                                                                            <span class="blue--text"> {{item.email}} </span>                                          
                                                                        </td> 
                                                                                                
                                                                                                                                        
                                                                        <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                          
                                                                    </tr>
                                                                </tbody>
                                                                
                                                            </template>
                                                                
                                                            <template v-slot:no-data>                                
                                                            <v-alert :value="true" color="error" icon="warning">
                                                                    Sorry, nothing to display here :(
                                                                </v-alert>
                                                            </template>
                                                            
                                                    </v-data-table>
                                                
                                                </template>

                                            </v-flex>

                                            <v-flex xs12 sm12 md12 lg12 xl12>
                                                <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                            </v-flex>


                                        </v-layout>             
                                     </v-container> 
<!--DataTable End -->

                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="hideContactList" color="blue darken" text>Cancel </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
<!--Contact list end -->








                <v-layout row wrap>                   
                
                   <v-flex xs10 sm10 md10 lg10 xl10>
                        <v-text-field v-model="frmFlowname"  label="Flow name"> </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4 lg4 xl4>
                            <v-select v-model="frmContactType" :items="contactType" label="Contact type"> </v-select>
                    </v-flex>	
                     <v-flex xs12 sm4 md4 lg4 xl4>
                        <v-text-field @keyup.enter="findContact()" v-model="frmContactBadgeid"  label="Contact badgeid"> </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2 md2 lg2 xl2>
                        <v-btn @click="showContactList" small fab dark color="teal">
                            <v-icon dark>list</v-icon>
                        </v-btn>
                    </v-flex>
                     <v-flex xs12 sm2 md2 lg2 xl2 v-if="errorContact">
                        <div class="red--text" v-text="errorContact">
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12 xl12>

                        <v-data-table 
                            :headers="headersDetail"
                            :items="DetailsContact"
                            :search="search"
                            hide-default-footer                          
                            class="elevation-1"
                            >
                            <template v-slot:top>
                                    <v-toolbar flat color="white"> 
                                    <v-toolbar-title>Contact list</v-toolbar-title> 
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>                    
                                       
                                    

                                      

                            <template>
                                    <v-row justify="center">
                                        <v-dialog v-model="dialog" persistent max-width="900px">
                                       <!-- <template v-slot:activator="{ on }" >
                                            <v-btn color="primary" dark v-on="on">New</v-btn>
                                        </template> -->
                                        <v-card>
                                            <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                            </v-card-title> 

                                        
                                            <v-card-text>                            
                                            <v-container>                              
                                                <v-flex xs12 sm12 md12 lg12 xl12>
                                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                                </v-flex>   
                                                <v-row>
                                                
                                                    <v-col cols="12" sm="6" md="4">
                                                        <v-text-field v-model="flowname" label="Flow Name" required></v-text-field>
                                                    </v-col>                                                                                                     
                                                                                                                
                                                </v-row>                            
                                            </v-container>
                                            <small>*indicates required field</small>
                                            </v-card-text>
                                            <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                                <v-btn
                                                    :disabled="dialogLoading"
                                                    :loading="dialogLoading"
                                                    color="blue darken-1" text @click="save"
                                                    >
                                                    Save
                                                </v-btn>
                                            
                                        
                                        <v-dialog
                                                v-model="dialogLoading"
                                                hide-overlay
                                                persistent
                                                width="300"
                                                >
                                                <v-card
                                                    color="primary"
                                                    dark
                                                >
                                                    <v-card-text>
                                                    Saving, please be patient.
                                                    <v-progress-linear
                                                        indeterminate
                                                        color="white"
                                                        class="mb-0"
                                                    ></v-progress-linear>
                                                    </v-card-text>
                                                </v-card>
                                                </v-dialog>            

                                            </v-card-actions>
                                        </v-card>
                                        </v-dialog>
                                    </v-row>
                                
                                    <v-row>
                                        <v-dialog v-model="adModal" persistent max-width="290px">
                                        <v-card>
                                            <v-card-title class="headline" v-if="adAccion == 1">Active Item?</v-card-title>
                                            <v-card-title class="headline" v-if="adAccion == 2">Desactive Item?</v-card-title>
                                            <v-card-text>
                                                Are you sure to
                                                <span v-if="adAccion==1">Activate </span>
                                                <span v-if="adAccion==2">Deactivate </span>
                                                this WorkFlow: {{adName}} ?
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green darken-1" text="text" @click="activateDesactivateClose">
                                                    Cancel
                                                </v-btn>
                                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activate">
                                                    Activate
                                                </v-btn>
                                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="deactivate">
                                                    Deactivate
                                                </v-btn>
                                                
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    </v-row>
                                
                                </template>

                                

                            </v-toolbar>
                            
                        </template>
                            
                                <template v-slot:body="{ items }">
                                    <tbody>
                                        <tr v-for="item in items" :key="item.ID">
                                            <td>
                                                <div >  
                                                    <div >                                  
                                                        <v-icon small class="mr-2" @click="deleteContact(DetailsContact,item)"> <!-- @click="editItem(item)"> -->
                                                            delete
                                                        </v-icon>                                                       
                                                       
                                                    </div>
                                                </div>                                                                                               
                                            </td>                  

                                            <td class="text-xs-right">                                               
                                                <v-text-field  
                                                filled
                                                rounded
                                                dense
                                                type="number" v-model="item.sequence"></v-text-field>                                      
                                             </td>                                                                       
                                            <td class="text-xs-right">
                                                <div v-if="item.contactType == 'Validator'">
                                                    <v-chip color="purple" dark>{{item.contactType}}</v-chip>                                                                                    
                                                </div>
                                                <div v-if="item.contactType == 'Approver'">                                                   
                                                    <v-chip color="orange" dark>{{item.contactType}}</v-chip>                                  
                                                </div>                                              
                                            </td> 
                                             <td class="text-xs-right">{{item.badgeid}} </td>
                                            <td class="text-xs-right">{{item.contactName}} </td> 
                                            <td class="text-xs-right">                                                
                                                <span class="blue--text"> {{item.email}} </span>                                          
                                            </td> 
                                                                       
                                                                                                            
                                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                          
                                        </tr>
                                    </tbody>
                                    
                                </template>
                                    
                                <template v-slot:no-data>                                
                                   <v-alert :value="true" color="error" icon="warning">
                                        Sorry, nothing to display here :(
                                    </v-alert>
                                </template>
                                
                        </v-data-table>

                    </v-flex>

                     <v-flex xs12 sm12 md12 lg12 xl12>
                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                     </v-flex>


                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-btn 
                         @click="hideNew()"  
                        color="blue darken-1" text>Cancel</v-btn>
                        <v-btn 
                        @click="save()"
                        color="success" >Save</v-btn>
                    </v-flex>

                </v-layout>             
           </v-container> 
 
        
                 
            

        </v-flex>

    
    </v-layout>  


    

</template>

  
        
        
        


<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  partnoAlt:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },                        
                       // { text: 'ID', value: 'id', sortable: false },
                        { text: 'Flow Name', value: 'flowname', sortable: false },                                               
                        { text: 'State', value: 'condition', sortable: false }                      
                    ],
                     headersDetail: [
                        { text: 'Delete', value: 'delete', sortable: false },       
                        { text: 'Send email', value: 'sequence', sortable: false },                 
                        { text: 'Contact type', value: 'contactType', sortable: false },
                        { text: 'Contact Badgeid', value: 'badgeid', sortable: false },
                        { text: 'UserName', value: 'contactName', sortable: false },                                               
                        { text: 'Email', value: 'email', sortable: false }                      
                    ],
                    DetailsContact: [
                        ],
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                    


                    verNuevo:0,
                    errorContact: null,

                    frmFlowname: '',
                    frmContactType: 'Validator',                    
                    contactType: ['Validator','Approver'],
                    frmContactBadgeid: '',

                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 


                    verContactos:0,
                    headersContact:[
                        { text: 'Select', value: 'select', sortable: false },                        
                        { text: 'Badgeid', value: 'badgeid', sortable: false },
                        { text: 'UserName', value: 'contactname' },
                        { text: 'Email', value: 'email', sortable: false }                      
                    ],
                    contactos:[],
                    texto:'',                
                   
                    valida:0,
                    validaMensaje:[],

                    adModal: 0,
                    adAccion: 0, 
                    adName: '',
                    adId: '',  

                    flowname: ''
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Contact' : 'Edit Contact'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listWorkflow();
            //this.havePriviges();     
        },

         methods: { 
           //   havePriviges() {
            //    this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            //} ,   
            
            showContactList(){
                this.verContactos = 1;
                //console.log(this.verContactos);
            },
            hideContactList(){
                this.verContactos = 0;
            },
            showNew(){
                this.verNuevo = 1;                
                //console.log("show New");
            },
            hideNew(){
                this.verNuevo = 0;
                this.clean();               
            },
             exitApp(){
                this.$store.dispatch("exit");
            }, 
            findContact(){  
                console.log('Buscar contacto');
                let me=this;

                me.errorContact = null;

                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_contact/BuscarContact/' + me.frmContactBadgeid;               
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.addContact(response.data);
                    me.frmContactBadgeid = '';
                    //me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);

                    me.errorContact = 'Contact no exist';
                })
            }, 
            listContact(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_contact/ListContact/' + me.texto;               
                axios.get(url,configuration).then(function(response){                   
                    me.contactos = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            addContact(data = []){
                this.errorContact = null;
                if (this.findDuplicate(data['id_contact'])){
                    this.errorContact = "Contact has already been added";
                }else{

                    var sendSequence = 0;
                    sendSequence  = this.DetailsContact.length +1;

                    this.DetailsContact.push(
                        {
                            id: data['id_contact']
                            ,sequence: sendSequence
                            ,contactType: this.frmContactType
                            ,badgeid: data['badgeid']
                            ,contactName: data['contactname']
                            ,email: data['email']
                        }
                    );
                }
            }, 
            findDuplicate(id){
                var sw = 0;
                for (var i=0; i < this.DetailsContact.length; i++){
                    if (this.DetailsContact[i].id == id){
                        sw = 1;
                    }
                }
                return sw;
            },
            deleteContact(arr, item){
                var sendSequence = 0;

                var i = arr.indexOf(item);
                if (i !== -1){
                    arr.splice(i,1);
                }

                for (var i=0; i < this.DetailsContact.length; i++){
                    sendSequence++
                    this.DetailsContact[i].sequence = sendSequence;

                }
            },          
            listWorkflow(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_workflow_master/List';               
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id_flow;  
                this.frmFlowname= item.flowname; 
                this.DetailsContact = item.details;
                this.showNew();
                //this.email= item.email; 
                //this.condition= item.condition;
                      
                this.editedIndex=1;
                //this.dialog = true
            },

            activeDesactiveItem (accion, item) {
                this.adModal= 1;
                this.adName = item.flowname;
                this.adId = item.id_flow;

                if (accion == 1){
                   this.adAccion = 1;
                } else if (accion == 2){
                    this.adAccion = 2;
                } else{
                   this.adModal= 0;
                }                
            },

            activateDesactivateClose(){
                this.adModal = 0;
            },

            activate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_workflow_master/Activate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listWorkflow();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },
            deactivate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_workflow_master/Desactivate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listWorkflow();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 

                this.frmFlowname = "";
                this.frmContactBadgeid = "";
                this.DetailsContact =[];

                this.contactname= "";
                this.email= "";
                this.condition= ""; 
                  
               
                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               

                    if ( this.editedIndex < 0)    
                    {    
                        //Code for Save                   
                        if (this.validar()){
                            return;
                        }

                        let me=this; 
                        let header={
                            "x-token": this.$store.state.token,
                            "Authorization": "Bearer " + this.$store.state.token                       
                            };   
                        //let header={"Authorization": "Bearer " + this.$store.state.token};
                        let configuration = {headers : header };
                        this.dialogLoading = true;         
                        axios.post('api/dell_sop_s_workflow_master/CreateWorkFlow',{                                                   
                                'flowname': me.frmFlowname,
                                'Details': me.DetailsContact                                 
                        },configuration).then(function(response){
                            //console.log('Save');
                            me.hideNew();
                            me.listWorkflow();
                            me.clean();
                            if (response.data.msg == 'Token no valid')
                            {
                                me.exitApp();
                            }
                        }).catch(function(error){                     
                        console.log(error);
                        }).finally(() => this.dialogLoading  = false,
                            this.validaMensaje.push('Workflow is already registered.')
                        );  
                    }
                    if ( this.editedIndex == 1)    
                    { 
                        //Code for Update                   
                        if (this.validar()){
                            return;
                        }

                        let me=this; 
                        let header={
                            "x-token": this.$store.state.token,
                            "Authorization": "Bearer " + this.$store.state.token                       
                            };   
                        //let header={"Authorization": "Bearer " + this.$store.state.token};
                        let configuration = {headers : header };
                        this.dialogLoading = true;         
                        axios.post('api/dell_sop_s_workflow_master/UpdateWorkflow',{ 
                                'id_flow' :  me.id,                                                
                                'flowname': me.frmFlowname,
                                'Details': me.DetailsContact                                 
                        },configuration).then(function(response){
                            //console.log('Save');
                            me.hideNew();
                            me.listWorkflow();
                            me.clean();
                            if (response.data.msg == 'Token no valid')
                            {
                                me.exitApp();
                            }
                        }).catch(function(error){                     
                        console.log(error);
                        }).finally(() => this.dialogLoading  = false,
                            this.validaMensaje.push('Workflow is already registered.')
                        );  
                        
                    }
                              
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.frmFlowname){
                     this.validaMensaje.push('Input flow name.');
                 }   
                 if (this.DetailsContact.length <= 0){
                     this.validaMensaje.push('Please add contacts to workflow.');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>